import { render, staticRenderFns } from "./JxdOrderList.vue?vue&type=template&id=0b2a9654"
import script from "./JxdOrderList.vue?vue&type=script&lang=js"
export * from "./JxdOrderList.vue?vue&type=script&lang=js"
import style0 from "./JxdOrderList.vue?vue&type=style&index=0&id=0b2a9654&prod&lang=less&scope=true"
import style1 from "./JxdOrderList.vue?vue&type=style&index=1&id=0b2a9654&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports